<template>
  <div class="bg-initial">
    <v-container fluid fill-height class="overlay">
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12" class="login-card">
          <v-card
            class="mx-auto"
            max-width="500"
            style="background: inherit;"
          >
            <v-card-text>
              <v-card-title align="center">
                <tw-logo-sistema/>
              </v-card-title>
              <div class="error--text"
                   v-if="error"
                   align="center">
                {{ error }}
              </div>
              <v-form
                class="login-content"
                ref="form"
              >
                <v-text-field
                  solo
                  v-model="user"
                  :error="$v.user.$error"
                  @blur="$v.user.$touch()"
                  label="E-mail"
                  required
                />
                <v-text-field
                  solo
                  hide-details
                  v-model="password"
                  label="Senha"
                  type="password"
                  :error="$v.password.$error"
                  @blur="$v.password.$touch()"
                  v-on:keyup.enter="doLogin"
                  required
                />
              </v-form>
              <v-row dense no-gutters class="mt-2 text-right">
                <v-col cols="12">
                  <tw-dialog-esqueceu-senha/>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn class="ma-2"
                     :disabled="loading"
                     @click="goToCriarConta">SOLICITAR ACESSO
              </v-btn>
              <v-btn color="primary"
                     :disabled="$v.$invalid"
                     :loading="loading"
                     @click="doLogin">Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import TwLogoSistema from '@/modules/login/TwLogoSistema.vue';
import { LOGIN } from './store/actions.type';
import DialogEsqueceuSenha from './DialogEsqueceuSenha.vue';

export default {
  computed: {
    ...mapGetters('login', {
      loading: 'loading',
      error: 'error',
    }),
    ...mapGetters({
      redirect: 'redirect',
    }),
    user: {
      get() {
        return this.$store.getters['login/user'];
      },
      set(user) {
        this.$store.dispatch('login/user', user);
      },
    },
    password: {
      get() {
        return this.$store.getters['login/password'];
      },
      set(password) {
        this.$store.dispatch('login/password', password);
      },
    },
  },
  methods: {
    ...mapActions('login', {
      logar: LOGIN,
    }),
    doLogin() {
      if (!this.user || !this.password) {
        return;
      }
      this.logar()
        .then(() => {
          if (this.redirect) {
            this.$router.push(this.redirect);
            return;
          }
          this.$router.push({ name: 'main' });
        });
    },
    goToCriarConta() {
      window.open('https://agendaplus.com.br/solicitacao.html', '_self');
    },
  },
  components: {
    TwLogoSistema,
    twDialogEsqueceuSenha: DialogEsqueceuSenha,
  },
  validations: {
    user: {
      required,
    },
    password: {
      required,
    },
  },
};
</script>

<style scoped>
.bg-initial {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/capa0.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
}

.bg-initial .overlay {
  background-color: rgba(143, 199, 74, 0.1);
  width: 100%;
}

.logo {
  width: 100px;
}

.login-content {
  padding-top: 15px;
}
</style>
